module.exports = __webpack_public_path__ + "static/img/procreate.e25e9c31.png";